import React, { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { TableInstance } from 'react-table';

import { BasicTableColumn, Table } from '@work4all/components';
import { Collapse } from '@work4all/components/lib/components/collapse';

import { Customer } from '@work4all/models/lib/Classes/Customer.entity';

import { ActionsBar } from '../../../../../../../../data-display/actions-bar/ActionsBar';
import { UpdateEntity } from '../../../../../../../components/update-entity/UpdateEntity';
import { useMaskContext } from '../../../../../../../hooks/mask-context';

export const CustomizedPrices = React.forwardRef<TableInstance>(
  (_props, ref) => {
    const { t } = useTranslation();

    const { data } = useMaskContext<Customer>();

    const columns = useMemo<BasicTableColumn[]>(() => {
      return [
        {
          Header: t('MASK.ARTICLE'),
          accessor: 'article.name',
          minWidth: 100,
        },
        {
          Header: t('MASK.ORDER_NUMBER'),
          accessor: 'articleNumber',
          minWidth: 100,
        },
        {
          Header: t('MASK.COMMENT'),
          accessor: 'comment',
          minWidth: 100,
        },
        {
          Header: t('MASK.PRICE'),
          accessor: 'netPrice',
          minWidth: 100,
          alignment: 'right',
          Cell: (value) => {
            const price = value.row.original['netPrice'];
            return price.toLocaleString();
          },
        },
      ];
    }, [t]);

    return (
      <Collapse
        grid={true}
        defaultOpen={true}
        headerBar={data?.id && <ActionsBar hideMoreButton />}
        title={t('MASK.CUSTOMIZED_PRICES')}
      >
        {!data?.id && <UpdateEntity />}
        {data?.id && (
          <Table
            ref={ref}
            cardsView={false}
            columns={columns}
            data={data?.customerIndividualPriceList}
            mode="client"
            allItemsCount={data?.customerIndividualPriceList?.length}
          />
        )}
      </Collapse>
    );
  }
);
